import React       from 'react';
import ReactDom    from 'react-dom';
import Moment      from 'moment';

import Const       from 'fw_const';
import Utils       from 'utils';

import ContentsModal    from 'contents_modal';
// -------------------------------------------------------

class Accordion extends React.Component {
  /*
   * コンストラクタ
   */
  constructor(props) {
    super(props);
    this.init(props);
  }
  // -------------------------------------------------------
  
  /*
   * ステートの設定
   */
  init(props) {
    this.state = {
      show : false,
    };
  }
  // -------------------------------------------------------
  
  /*
   * ステートの設定
   */
  toggleAccordion(flg) {
    this.setState({ show: (this.state.show == true) ? false : true });
  }
  // -------------------------------------------------------
  
  render() {
    let list = this.props.menus;
    
    let is_show = (this.state.show == true) ? 'show' : 'hidden';
    
    return (
      <div className={'accordion '+ is_show}>
        <h3 onClick={this.toggleAccordion.bind(this)}>{this.props.name}</h3>
        
        <div className="accordion-items">
          { this.props.menus.map((d, key) => {
            let _html = React.cloneElement(d, { key: key, set_ev: this.props.set_ev.bind(this) })
            return _html;
          })}
        </div>
      </div>
    );
  }
}
// -------------------------------------------------------

// レンダリング処理
export default Accordion;